import React, { Component } from 'react';
import InputField from "../../input-field/InputField";
import { validation } from "../primary-email-validation/PrimaryEmailValidation";
import * as ReactSpark from "react-spark";

const { Stack } = ReactSpark;
const { Item } = Stack;

class EmailWithConfirmation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            emailConfirm: ''
        };
    }

    handleEmail = (e) => {
        this.setState({ email: e.target.value });
    }

    handleEmailConfirmation = (e) => {
        this.setState({ emailConfirm: e.target.value });
    }

    render() {
        const {
            email,
            emailConfirm
        } = this.state;

        return (
            <Stack splitAt="small">
                <Item breakpoint="small" width="half">
                    <InputField
                        id={'email'}
                        name={'email'}
                        type='email'
                        placeholder={'Email Address'}
                        value={email}
                        changeCallback={this.handleEmail}
                        validation={validation}
                    />
                </Item>
                <Item breakpoint="small" width="half">
                    <InputField
                        id={'confirmEmail'}
                        name={'confirmEmail'}
                        type='email'
                        placeholder={'Confirm Email Address'}
                        value={emailConfirm}
                        changeCallback={this.handleEmailConfirmation}
                        validation={{
                            validateOn: ['blur'],
                            required: true,
                            checkValidity: () => email === emailConfirm,
                            message: {
                                default: 'Email Addresses do not match'
                            }
                        }}
                    />
                </Item>
            </Stack>
        );
    }
}

export default EmailWithConfirmation;
